import { TypeUrlData } from './urlData.interface'

type TypeManagedQueues = Record<string, TypeUrlData[]>
class LinkQueue {
  private static instance: LinkQueue

  private _managedQueues: TypeManagedQueues = {}

  private constructor() {
    // do nothing
  }

  public static getInstance(): LinkQueue {
    if (!LinkQueue.instance) {
      LinkQueue.instance = new LinkQueue()
    }
    return LinkQueue.instance
  }

  // returns current queue for a dataset and removes any duplicates
  getQueue(dataset_uuid: string): TypeUrlData[] {
    if (!this._managedQueues[dataset_uuid]) {
      this._managedQueues[dataset_uuid] = []
    }
    this.removeDuplicatesFromQueue(dataset_uuid)
    return this._managedQueues[dataset_uuid]
  }

  // adds a link to a dataset queue
  addLinkToQueue(dataset_uuid: string, link: TypeUrlData): void {
    if (!this._managedQueues[dataset_uuid]) {
      this._managedQueues[dataset_uuid] = []
    }

    this._managedQueues[dataset_uuid].push(link)
  }

  // adds an array of links to a dataset queue
  addLinkBatchToQueue(dataset_uuid: string, links: TypeUrlData[]): void {
    if (!this._managedQueues[dataset_uuid]) {
      this._managedQueues[dataset_uuid] = []
    }

    this._managedQueues[dataset_uuid].concat(links)
  }

  emptyQueue(dataset_uuid: string): void {
    this._managedQueues[dataset_uuid] = []
  }

  private removeDuplicatesFromQueue(dataset_uuid: string): void {
    if (!this._managedQueues[dataset_uuid]) {
      return
    }

    const uniqueUrls = {}

    for (const urlData of this._managedQueues[dataset_uuid]) {
      if (!uniqueUrls[urlData.url]) {
        uniqueUrls[urlData.url] = urlData
      }
    }

    this._managedQueues[dataset_uuid] = Object.values(uniqueUrls)
  }
}

export const linkQueue = LinkQueue.getInstance()
